<div class="data-table" [class.data-table--refreshing]="isRefreshing">
  @if (isRefreshing) {
    <div class="data-table__refresh-bar" role="status">
      <span class="data-table__refresh-spinner" aria-hidden="true"></span>
      <span>Loading page...</span>
    </div>
  }

  <div class="data-table__scroll">
    <table class="data-table__table">
      <thead>
        <tr>
          @for (col of columns; track col.key) {
            <th [style.width]="col.width">{{ col.label }}</th>
          }
          @if (actions.length) {
            <th class="data-table__actions-head">Actions</th>
          }
        </tr>
      </thead>
      <tbody>
        @if (isLoading && !data.length) {
          @for (_ of skeletonRows; track $index) {
            <tr class="data-table__skeleton-row">
              @for (col of columns; track col.key) {
                <td><span class="data-table__skeleton"></span></td>
              }
              @if (actions.length) {
                <td><span class="data-table__skeleton data-table__skeleton--sm"></span></td>
              }
            </tr>
          }
        } @else if (!data.length) {
          <tr>
            <td [attr.colspan]="columns.length + (actions.length ? 1 : 0)" class="data-table__empty">
              <div class="data-table__empty-state">
                <span class="data-table__empty-icon" aria-hidden="true">◇</span>
                <p>{{ emptyMessage }}</p>
              </div>
            </td>
          </tr>
        } @else {
          @for (row of data; track $index; let i = $index) {
            <tr>
              @for (col of columns; track col.key) {
                <td>
                  @if (col.type === 'status') {
                    <span class="data-table__status" [class]="getStatusClass(row, col.key)">
                      {{ getValue(row, col.key) }}
                    </span>
                  } @else if (col.type === 'boolean') {
                    <span class="data-table__bool" [class.data-table__bool--yes]="getValue(row, col.key) === 'Yes' || getValue(row, col.key) === true">
                      {{ getValue(row, col.key) ? 'Yes' : 'No' }}
                    </span>
                  } @else if (col.key === 'featureGroup') {
                    {{ getLabelValue(row, col.key) | labelFromValue: featureGroupOptions }}
                  } @else if (col.key === 'featureType') {
                    {{ getLabelValue(row, col.key) | labelFromValue: featureTypeOptions }}
                  } @else if (col.key === 'planType') {
                    {{ getLabelValue(row, col.key) | labelFromValue: planTypeOptions }}
                  } @else {
                    {{ getValue(row, col.key) }}
                  }
                </td>
              }
              @if (actions.length) {
                <td class="data-table__actions">
                  <button
                    type="button"
                    class="data-table__menu-trigger"
                    (click)="toggleMenu(i, row, $event)"
                    [attr.aria-expanded]="openMenuIndex() === i"
                    aria-label="Open row actions"
                  >
                    ⋮
                  </button>
                </td>
              }
            </tr>
          }
        }
      </tbody>
    </table>
  </div>

  @if (totalItems > size) {
    <app-pagination
      [currentPage]="page"
      [pageSize]="size"
      [totalItems]="totalItems"
      [disabled]="isRefreshing"
      (pageChange)="pageChange.emit($event)"
    />
  }
</div>

@if (openMenuIndex() !== null && menuPosition() && activeRow()) {
  <div class="data-table__menu-panel" [style.top.px]="menuPosition()!.top" [style.left.px]="menuPosition()!.left">
    @for (action of getActionsForRow(activeRow()!); track action.mode) {
      <button
        type="button"
        class="data-table__menu-item"
        [class.data-table__menu-item--danger]="action.variant === 'danger'"
        (click)="onAction(action.mode, activeRow()!, $event)"
      >
        {{ action.label }}
      </button>
    }
  </div>
}
